import { SETTINGS } from "../constants";

const initialState = {
  especialidades: [
    "Cirugía General",
    "Medicina Interna",
    "Pediatría",
    "Ginecología y Obstetricia",
    "Cirugía Pediátrica y del Adolescente",
    "Urología",
    "Otorrinolaringología",
    "Traumatología",
    "Cardiología",
    "Endocrinología",
    "Dermatología",
    "Nutricionista",
    "Psicología",
    "Neumonología",
    "Neurología",
    "Oftalmología",
    "Nefrología",
    "Cirugía Oncológica",
    "Gastroenterología",
    "Odontología",
    "Oncología Médica",
    "Medicina General",
    "Cirujano General",
  ],
  contacto: {
    phone: "0414-7131791",
    whatsapp: "584147131791",
    mail: "",
    address: "Barinas, Estado Barinas. Diagonal a la Entrada de la Emergencia del Hospital Dr. Luis Razetti",
    contactName: "Ing. Sandra Scelli Azan",
    contactTitle: "Vice-Presidente Servital Salud",
  },
  displayTimezone: "America/Caracas",
  modeloEco: "Mindray Modelo Z60",
  ecografias: [
    "Tiroides", "Mamario", "Pulmonar", "Abdominal", "Renal",
    "Pélvico", "Ginecológico", "Obstétrico", "Prostático",
    "Músculo-Esquelético", "Partes Blandas", "Doppler",
  ],
  estudios: [
    { id: 1, name: "MAPA de Tensión Arterial", price: "$35", note: "Incluye Informes" },
    { id: 2, name: "Holter de Ritmo Cardíaco", price: "$35", note: "Incluye Informes" },
    { id: 3, name: "Ecocardiograma (ECG)", price: "$45", note: "Incluye Informes" },
    { id: 4, name: "Espirometría", price: "$10", note: "Solo el Estudio" },
    { id: 5, name: "Doppler Carotídeo", price: "$80", note: "Estudio Informado" },
    { id: 6, name: "Doppler de Miembros Superiores e Inferiores", price: "Consultar", note: "" },
  ],
  consultas: [
    {
      id: 1, group: "Consultas — Grupo A", note: "Incluye ecografía", price: "$20",
      items: ["Cirugía General", "Urología", "Ginecología", "Cirugía Pediátrica y del Adolescente", "Nefrología"],
    },
    {
      id: 2, group: "Consultas — Grupo B", note: "Primera vez o control", price: "$20",
      items: ["Cardiología", "Neumonología", "Medicina Interna", "Endocrinología", "Pediatría", "Dermatología", "Nutrición", "ORL", "Traumatología", "Psicología"],
    },
    { id: 3, group: "Neurología", note: "Primera vez o control", price: "$35", items: [] },
    { id: 4, group: "Oftalmología", note: "Patología, Fondo de Ojo, Tensión y Fórmula", price: "$40", items: [] },
  ],
  convenios: [
    { id: 1, category: "Laboratorios", discount: "5% – 10%", partners: "Laboratorio Beraca · Laboratorio Caridad" },
    { id: 2, category: "Farmacias", discount: "10%", partners: "Farmaberaca · Farmadeli" },
    { id: 3, category: "Resonancias y Tomografías", discount: "10%", partners: "Clínica Nuestra Sra. del Pilar" },
    { id: 4, category: "Radiografías", discount: "10%", partners: "Imágenes Dr. José Gregorio Hernández" },
    { id: 5, category: "Odontología", discount: "Descuento especial", partners: "Clínica Nuestra Sra. del Pilar" },
  ],
};

const settingsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SETTINGS.GET_SETTINGS_SUCCESS:
      return { ...state, ...action.payload };
    case SETTINGS.UPDATE_CONTACTO:
      return { ...state, contacto: action.payload };
    case SETTINGS.UPDATE_ECOGRAFIAS:
      return { ...state, ecografias: action.payload };
    case SETTINGS.UPDATE_ESTUDIOS:
      return { ...state, estudios: action.payload };
    case SETTINGS.UPDATE_CONSULTAS:
      return { ...state, consultas: action.payload };
    case SETTINGS.UPDATE_MODELO_ECO:
      return { ...state, modeloEco: action.payload };
    case SETTINGS.UPDATE_CONVENIOS:
      return { ...state, convenios: action.payload };
    case SETTINGS.UPDATE_ESPECIALIDADES:
      return { ...state, especialidades: action.payload };
    case SETTINGS.UPDATE_DISPLAY_TIMEZONE:
      return { ...state, displayTimezone: action.payload };
    default:
      return state;
  }
};

export default settingsReducer;
